(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7870],{

/***/ 27870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ components_Customer_Customer; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/Customer/assets/Customer@2x.png
var Customer_2x = __webpack_require__(73541);
var Customer_2x_default = /*#__PURE__*/__webpack_require__.n(Customer_2x);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/Customer/assets/Customer.webp
var Customer = __webpack_require__(93858);
var Customer_default = /*#__PURE__*/__webpack_require__.n(Customer);
// EXTERNAL MODULE: ./src/views/Product/LandingPage/components/Customer/assets/Customer@2x.webp
var assets_Customer_2x = __webpack_require__(31996);
var assets_Customer_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Customer_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Product/LandingPage/components/Customer/CustomerImage.tsx







var CustomerImage = function CustomerImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Customer_default()), ", ").concat((assets_Customer_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (Customer_2x_default()),
      alt: "Customer",
      width: "640",
      height: "439",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var Customer_CustomerImage = (CustomerImage);
;// CONCATENATED MODULE: ./src/views/Product/LandingPage/components/Customer/Customer.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var copy = {
  overline: "Segment for Marketing Teams",
  heading: "Complete view of the customer",
  description: "Unify your customer\u2019s touch points across all platforms and channels."
};
var Customer_link = {
  text: "Explore Segment for Marketers",
  url: "/product/twilio-engage/"
};

var Customer_Customer = function Customer() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            children: copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
            size: "medium",
            tag: "a",
            href: (0,getAbsoluteUrl/* default */.Z)(Customer_link.url, pageConfig),
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: Customer_link.text
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Customer_CustomerImage, {})
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1fwd66t3"
} : 0)("display:grid;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:20px;}" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1fwd66t2"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1fwd66t1"
} : 0)( true ? {
  name: "1n8met0",
  styles: "padding-top:0"
} : 0);

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1fwd66t0"
} : 0)("display:flex;align-items:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:392px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var components_Customer_Customer = (Customer_Customer);
;// CONCATENATED MODULE: ./src/views/Product/LandingPage/components/Customer/index.ts


/***/ }),

/***/ 73541:
/***/ (function(module) {

module.exports = "/_next/static/images/Customer@2x-9140999df358d92091c1d39087453df8.png";

/***/ }),

/***/ 93858:
/***/ (function(module) {

module.exports = "/_next/static/images/Customer-81950954e0648b83b0b0dba37a208978.webp";

/***/ }),

/***/ 31996:
/***/ (function(module) {

module.exports = "/_next/static/images/Customer@2x-111bbf6a6fe62d6c140eb883c4a674ac.webp";

/***/ })

}]);